import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { HttpService } from '../../../http.service';
import { NotificationService } from '../../../notification.service';
import { environment } from '../../../../environments/environment';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { DatePipe } from '@angular/common';
import { Router } from  '@angular/router';
import { NgEventBus } from 'ng-event-bus';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { TimeChangeServiceService } from '../../../time-change-service.service';
import { Subscription } from 'rxjs';

import { ShareddataService } from '../../../shareddata.service';
declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers: [DatePipe]
})
export class FooterComponent implements OnInit {
	opts: ISlimScrollOptions;
	scrollEvents: EventEmitter<SlimScrollEvent>;
	minTime: Date = new Date();
	maxTime: Date = new Date();
	is_d_error = '0';
	cartModelServiceErrorMessage:any='';
	cartModelService:any=[];
	cartModelData:any=[];
	subMeuData:any=[];
	dealMenuData:any=[];
	isLogin:String='0';
	loginSpin:Number=0;
	subMeuName:String;
	qty:Number;
	subMeuprice:any;
	subMeuDesc:any;
	subMeuSizes:any;
	modifersData:any;
	ItemBasePrice: number =0.00;
	cartTotalBalance: any =0.00;
	submeuGrandPrice: number =0.00;
	oldSubmeuGrandPrice:number;
	modifersSlected: any = [];
	orderQty : any =1;
	selectedIndexOfelement : any =0;
	selected_modifers : any=0;
	issubmenuSize : any =0;
	is_future_enable : any ='0';
	slectedMenuSize: string = '';
	slectedMenuSizeIndex: string = '';
	myCartDateTime: any;
	itemType : String ='M';
	mytime: any = new Date();
	modiferLastRadioButton : any =[];
	responseHeaderData : any =[];
	BASEURL_SUBMENU_IMGS = environment.BASEURL_SUBMENU_IMGS;
	BASEURL_DEAL_IMGS = environment.BASEURL_DEAL_IMGS;
	BASEURL_RES_IMGS = environment.BASEURL_RES_IMGS;

	bookOrderValidationMessage : any ="";
	isCartData: String ='0';
	selectedOrderServiceType : any = localStorage.getItem('selectedOrderService');
	restaurantData : any = JSON.parse(localStorage.getItem('restaurant'));
	item_special_instructions_view : any = '0';
	modifersDataSpin:any=0;
	isSubmittedForgot  =  false;

	logoImage='assets/img/logo.png';
	editCartObject : any =[];
	topping_counter_limit : any ='';
	loginErrorMessage : any ='';
	forGotPasswordMessageApi : any ='';
  
	orderDateSelected :any = new Date();
	bsValue = new Date();
	bsRangeValue: Date[];
	maxDate = new Date();
	minDate = new Date();
   	forGotPasswordSpin:Number=0;
	forgotForm: FormGroup;
  
    private sub!: Subscription;

  constructor(
		private _http: HttpService, 
		private sharedService: ShareddataService,
		private datePipe : DatePipe,
		public router: Router,
		private notifyService : NotificationService,
		private eventBus: NgEventBus,
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private timeChangeService: TimeChangeServiceService

	) {
		this.cartItemDateTime();
		var hours = this.datePipe.transform(new Date(), 'H');
		var min = this.datePipe.transform(new Date(), 'm');
		this.minTime.setHours(parseInt(hours));
		this.minTime.setMinutes(parseInt(min));
		this.maxTime.setHours(23);
		this.maxTime.setMinutes(59);
		
		
		const url_store_id: string = this.route.snapshot.queryParamMap.get('store_id');
		if (url_store_id) {
			localStorage.setItem("url_store_id", url_store_id);
		} 
		
		this.sub = this.timeChangeService.timeChanged$.subscribe(drift => {
		 
		  
		});
	}

  ngOnInit(): void {
	this.maxDate.setDate(this.maxDate.getDate() + 6);
	this.bsRangeValue = [this.bsValue, this.maxDate];
	this.topping_counter_limit = localStorage.getItem('topping_counter_limit');
	$('#customizeModal').modal('hide');
    $( ".cart-trigger" ).on('click', function(){
		if ($('body').hasClass('cart-open')) {
			$('html').css('overflow','auto');
		} else {
			$('html').css('overflow','hidden');
		}
	});	
	
	if (localStorage.getItem("orderDate")!=null) {
		this.orderDateSelected= new Date(localStorage.getItem("orderDate")) ;
	} 
	if(localStorage.getItem("orderDatetime")!=null){
		this.mytime=localStorage.getItem("orderDatetime");
		var orderTimeLocal = this.datePipe.transform(this.mytime, 'h:mm a');
		var orderDateLocal = this.datePipe.transform(localStorage.getItem("orderDate"), 'EEEE, MMMM d');
		this.myCartDateTime=orderDateLocal+' '+orderTimeLocal;
	}else{
		this.myCartDateTime=this.datePipe.transform(this.mytime, 'EEEE, MMMM d h:mm a');
	}
	if (this.restaurantData) {
		this.item_special_instructions_view=this.restaurantData.item_special_instructions_view;
	}
	//this.logoImage=localStorage.getItem('logoImage');
	
	this.eventBus.on('resSettingsData:cal').subscribe((resSettingsData: any) => {
		this.responseHeaderData=resSettingsData.data;
		
		if (this.responseHeaderData.data.restaurant.is_future_enable) {
			this.is_future_enable = this.responseHeaderData.data.restaurant.is_future_enable;
		}
		if (this.is_future_enable==="0") {
			this.orderDateSelected= new Date() ;
			localStorage.setItem("orderDate", this.orderDateSelected)
		}
		
		if(this.responseHeaderData.data.setting){
		  if(this.responseHeaderData.data.setting.res_icon!=''){
			this.logoImage=this.BASEURL_RES_IMGS+this.responseHeaderData.data.setting.res_icon;
			
		  }
		}
	});
	this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.opts = {
      position: 'right',
      barBackground: 'rgb(78, 78, 78)',
      barOpacity: '0.8',
      barWidth: '10',
      
      barBorderRadius:'2',
      barMargin: '0',
      gridBackground: '#D9D9D9',
      gridOpacity: '1', 
      gridWidth: '2',
      gridBorderRadius: '20',
      gridMargin: '0',
      alwaysVisible: true,
      visibleTimeout: 1000,

      alwaysPreventDefaultScroll: true,
    }
	
	this.forgotForm  =  this.formBuilder.group({
			//forgotemail: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
			forgotemail: ['', [Validators.required]]
		});
		
	this.sharedService.sharedSubMenuCartData.subscribe((response: any) => {
		this.bookOrderValidationMessage='';
		if(response.name){
			this.dealMenuData=[];
			this.modifersSlected=[];
			this.subMeuData=response;
			this.subMeuName=response.name;
			this.subMeuDesc=response.desc;
			this.subMeuprice=parseFloat(response.price);
			if(response.price!='' && isNaN(response.price)==false){
				this.ItemBasePrice=parseFloat(response.price);
				this.submeuGrandPrice=parseFloat(response.price);
				this.subMeuprice=parseFloat(response.price);
			}else{
				this.ItemBasePrice=0.00;
				this.submeuGrandPrice=0.00;
				this.subMeuprice=0.00;
			}
			this.subMeuSizes= [];
			
			if(response.is_size_applicable==='1'){
				this.subMeuSizes = JSON.parse(response.menu_size);
				
				if(this.subMeuSizes!=null){
					if(this.subMeuSizes.length>0){
						this.issubmenuSize=1;
						this.ItemBasePrice=parseFloat(this.subMeuSizes[0].amount);
						this.submeuGrandPrice=parseFloat(this.subMeuSizes[0].amount);
						this.slectedMenuSize=this.subMeuSizes[0].size;
						this.slectedMenuSizeIndex=this.subMeuSizes[0].index;
					}
				}
				
			}else{
				this.issubmenuSize=0;
				this.slectedMenuSize='';
				this.slectedMenuSizeIndex='';
			}
			$('#special_instruction').val('');
			this.modifersData=[];
			if(response.dealData) {
				this.modifersData=response.dealData.deal_addons;
				this.dealMenuData=response.dealData.menu_list;
				
			} else {
				this.getModiferData(response.id,response.menu_id);
			}
			if(response.id) {
				
				$('.orderCartModalSubMenuImage').attr("src", $('#submenu_image_'+response.id).attr('src'));
			} else {
				$('.orderCartModalSubMenuImage').attr("src", "assets/img/prods-sm/5.png");
			}
			setTimeout(() => {
				$('input[type=checkbox]').prop('checked',false); 
			}, 100);
			this.orderQty=1;
			$('.qtyvalue').val('1');
			
		}
	});
	this.cartModeldata();
	this.updateMaxMinTime();
  }
  
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  cartItemDateTime(){
	var isvalid ='1';
	var orderData:any=localStorage.getItem('orderData');
	if(orderData!=null){
		orderData = JSON.parse(orderData);
		for (var i=0;i<orderData.length;i++) {
			
			const givenDate:any= new Date(orderData[i].date);
			const currentDate:any = new Date();
			
			const diffMs = currentDate - givenDate; // Difference in milliseconds
			const diffHours = diffMs / (1000 * 60 * 60); // Convert to hours
			const diffMinutes = diffMs / (1000 * 60); // Convert to minutes
			
			
			if (diffHours>4) {
			//if (diffMinutes>5) {
				alert("Order Timed Out - Order Lost, Please login and try again");
				localStorage.removeItem('isLogin');
				localStorage.removeItem('orderData');
				

				localStorage.removeItem('isLogin');
				localStorage.removeItem('user_detail');
				localStorage.removeItem('jwt_token');
				localStorage.removeItem('is_call');
				var root = this;
				isvalid ='0';
				setTimeout(() => {
				  this.router.navigateByUrl('/login');
				}, 500);
		
				//window.location.href='/login';
			}
			
		}
		
	}
	return isvalid;
  }
  
  getModiferData(id,menu_id){
	var userId=25;
	if (this.responseHeaderData.data) {
		if (this.responseHeaderData.data.guest_data.user_id) {
			userId = this.responseHeaderData.data.guest_data.user_id;
		}
	}

	if (this.issubmenuSize==0){
		$('#orderNow').prop('disabled', true);
		$('#orderNow').removeClass('btn-custom');	
		$('#orderNow').addClass('disable-btn-custom');	
	}
	
	var token=localStorage.getItem('jwt_token');
	var queryParms='sub_menu_id='+id+'&user_id='+userId+'&menu_id='+menu_id;
	this.modiferLastRadioButton=[];
	this.modifersDataSpin=1;
	this._http.getRequest('get_modifierdata.php?'+queryParms,token).subscribe((data: any) => {
		this.modifersDataSpin=0;
		$('#orderNow').prop('disabled', false)	
		$('#orderNow').addClass('btn-custom');	
		$('#orderNow').removeClass('disable-btn-custom');	
		
		if(data.success==='1'){
			this.modifersData=data.data;
			setTimeout(()=>{   
				for (var i=0;i<this.modifersData.length; i++) {
					
					for (var j=0;j<this.modifersData[i].data.length; j++) {
						if (this.modifersData[i].modifier_type==='2') {
							this.selectthebyDefaultModifers( this.modifersData[i].data[j] ,this.modifersData[i], 'checkbox', i);
							
							if (this.modifersData[i].data[j].free==2) {
								this.changeModiferSizesQty(this.modifersData[i].data[j],this.modifersData[i], 'add', 'api');
							}
							if (this.modifersData[i].data[j].free==3) {
								this.changeModiferSizesQty(this.modifersData[i].data[j],this.modifersData[i], 'add' , 'api');
								this.changeModiferSizesQty(this.modifersData[i].data[j],this.modifersData[i], 'add', 'api');
							}
							
						} else if (this.modifersData[i].modifier_type==='1') {
							if (this.modifersData[i].data[j].free!='') {
								
								this.selectthebyDefaultModifers( this.modifersData[i].data[j] ,this.modifersData[i], 'radio', i );
								
								$('#regular_'+this.modifersData[i].modifier_id+'_'+this.modifersData[i].data[j].index).prop("checked", true);
								
								if (this.modifersData[i].data[j].free==2) {
									this.changeModiferSizesQty(this.modifersData[i].data[j],this.modifersData[i], 'add',  'api');
								}
								if (this.modifersData[i].data[j].free==3) {
									this.changeModiferSizesQty(this.modifersData[i].data[j],this.modifersData[i], 'add', 'api');
									this.changeModiferSizesQty(this.modifersData[i].data[j],this.modifersData[i], 'add', 'api');
								}
							
							}
						}
					}
				}
			}, 500);
			
			
		} else  {
			this.modifersData = [];
		}
	}
	);  
  }
  
  //Changing the total price according to the size
  /* changedtotalPrice(sizePrice,index,slectedsize, sizeIndex){
	this.ItemBasePrice=parseFloat(sizePrice);

	$(".selected-size").removeClass("selected-size")
	$('#submenusize_'+index).addClass('selected-size');
	this.slectedMenuSize=slectedsize;
	this.slectedMenuSizeIndex=sizeIndex;
	this.selected_modifers=0;
	
	let total_free = 0;
	
	for (var i=0; i<this.modifersSlected.length; i++){
		let changetotalpriceqty=0;
		let pizaextra_price=0;
		let free_price = 0;
		changetotalpriceqty=parseFloat(this.orderQty)*parseFloat(this.modifersSlected[i].amount);
		
		let pizaExtra:any = this.getPizaTypeExtraPriceAndLabel(this.modifersSlected[i].modiferObject, this.modifersSlected[i].pizaextra_name);

		
		if(this.modifersSlected[i].pizaextra_price) {
			pizaextra_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
			//Mutliplying With Qty
			pizaextra_price = pizaextra_price * parseFloat(this.modifersSlected[i].pizaextra_price_qty);
			
			if (this.modifersSlected[i].free==='full' || this.modifersSlected[i].free==='left' || this.modifersSlected[i].free==='right') {
				free_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
				free_price = free_price *1;
				pizaextra_price = free_price;
			}else if ( this.modifersSlected[i].free==2 ) {
				free_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
				free_price = free_price *2;
				pizaextra_price = free_price;
			}else if ( this.modifersSlected[i].free==3 ) {
				free_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
				free_price = free_price *3;
				pizaextra_price = free_price;
			}
			total_free = total_free+free_price;
			
			
		}
		console.log(free_price, "free_price");
		console.log(pizaextra_price, "pizaextra_price");
		
		changetotalpriceqty=parseFloat(this.selected_modifers)+changetotalpriceqty+pizaextra_price;
		this.selected_modifers=changetotalpriceqty;
		
		if (pizaExtra.pizaextra_name) {
			this.modifersSlected[i].pizaextra_price = parseFloat(pizaExtra.selectedSizePrice);
			this.modifersSlected[i].pizaextra_name = pizaExtra.pizaextra_name;
		}
		
	}
	
	
	sizePrice=parseFloat(this.orderQty)*parseFloat(sizePrice);
	this.submeuGrandPrice=parseFloat(sizePrice)+this.selected_modifers;
	this.submeuGrandPrice = this.submeuGrandPrice-total_free;

  } */
   //Changing the total price according to the size
  changedtotalPrice(sizePrice,index,slectedsize, sizeIndex){
	this.ItemBasePrice=parseFloat(sizePrice);

	$(".selected-size").removeClass("selected-size")
	$('#submenusize_'+index).addClass('selected-size');
	this.slectedMenuSize=slectedsize;
	this.slectedMenuSizeIndex=sizeIndex;
	this.selected_modifers=0;
	for (var i=0; i<this.modifersSlected.length; i++){
		let changetotalpriceqty=0;
		let pizaextra_price=0;
		let free_price = 0;

		changetotalpriceqty=parseFloat(this.orderQty)*parseFloat(this.modifersSlected[i].amount);
		
		let pizaExtra:any = this.getPizaTypeExtraPriceAndLabel(this.modifersSlected[i].modiferObject, this.modifersSlected[i].pizaextra_name);
		
		if (pizaExtra.pizaextra_name) {
			this.modifersSlected[i].pizaextra_price = parseFloat(pizaExtra.selectedSizePrice);
			this.modifersSlected[i].pizaextra_name = pizaExtra.pizaextra_name;
		}
		
		if(this.modifersSlected[i].pizaextra_price!='') {
			pizaextra_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
			//Mutliplying With Qty
			pizaextra_price = pizaextra_price * parseFloat(this.modifersSlected[i].pizaextra_price_qty);
			
			if (this.modifersSlected[i].free==='full' || this.modifersSlected[i].free==='left' || this.modifersSlected[i].free==='right') {
				free_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
				free_price = free_price *1;
			}else if ( this.modifersSlected[i].free==2 ) {
				free_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
				free_price = free_price *2;
			}else if ( this.modifersSlected[i].free==3 ) {
				free_price=parseFloat(pizaExtra.selectedSizePrice)*parseFloat(this.orderQty);
				free_price = free_price *3;
			}
			pizaextra_price = pizaextra_price;
			
			
		}
		
		
		changetotalpriceqty=parseFloat(this.selected_modifers)+changetotalpriceqty+pizaextra_price;
		this.selected_modifers=changetotalpriceqty;
		
		
		
	}
	
	
	sizePrice=parseFloat(this.orderQty)*parseFloat(sizePrice);
	this.submeuGrandPrice=parseFloat(sizePrice)+this.selected_modifers;
	
	for ( var i=0;i<this.modifersData.length;i++) {
		var match_any = "0";
		for ( var j=0;j<this.modifersSlected.length;j++) {
			if (this.modifersSlected[j].modifer_id === this.modifersData[i].modifer_id) {
				match_any = "1";
			}
		}
		if (match_any === "1") {
			var appliedprice = this.appliedModifersPrice(this.modifersData[i], this.modifersData[i]);
			var freePrice = this.freePriceForModifer(this.modifersData[i], this.modifersData[i]);
			var pizatoppingMinus = appliedprice-freePrice
			
			freePrice = freePrice*parseFloat(this.orderQty);
			appliedprice = appliedprice*parseFloat(this.orderQty);
			if(pizatoppingMinus>=0) {
				this.submeuGrandPrice = this.submeuGrandPrice - freePrice;
			} else if ( appliedprice<freePrice ) {
				this.submeuGrandPrice = this.submeuGrandPrice - appliedprice;

			}
			
		} 
	}
	
  }
  //price changed on the Radion Button change
  onRadioButtonChange(eve: any,modifernextdata:any,modifer:any){
	//For Piza Topping And Extra
	$('#circel-icon-left-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('fa-circel-icon-selected');
	$('#circel-icon-full-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('fa-circel-icon-selected');
	$('#circel-icon-right-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('fa-circel-icon-selected');
	if (modifernextdata.type==='piza') {
		eve.target.value = 0;
	}	
	
	var qty=parseFloat(this.orderQty)*parseFloat(eve.target.value);
	var oldValue:any='';
	var oldId='';
	//Gett the old amount of radion button and removed the Old value object from array
	for(var i=0;i<this.modiferLastRadioButton.length;i++ ){
		if(this.modiferLastRadioButton[i].name==eve.target.name){
			oldValue=this.modiferLastRadioButton[i].lastvalue;
			oldId=this.modiferLastRadioButton[i].oldId;
			var oldIdSplit = oldId.split('_');
			if (oldIdSplit[1]) {
				$('.piza-icons-'+oldIdSplit[1]+'-'+oldIdSplit[2]).hide();
				$('.piza-top-counter-'+oldIdSplit[1]+'-'+oldIdSplit[2]).hide();
			}
			this.modiferLastRadioButton.splice(i, 1); 
		}
	}
	//Push the latest radion value on to the array
	var selectedRadioButton = {'name': eve.target.name,'lastvalue':eve.target.value, oldId:eve.target.id};
	
	this.modiferLastRadioButton.push(selectedRadioButton);
	
	//Added the new amount on cart by selection of radio button
	if (eve.target.checked) {
		var amount=qty+this.submeuGrandPrice;
		amount=amount;
		this.submeuGrandPrice=amount;
		var pushModiferArray={
			'id': modifernextdata.index,
			'code': modifernextdata.code,
			'modifier_id': modifer.modifier_id,
			'name': modifernextdata.modifier_name,
			'modifier_sequence': modifer.modifier_sequence,
			'free': modifernextdata.free,
			'div_id': eve.target.id,
			'amount' : eve.target.value,
			'pizaextra_name' : '',
			'pizaextra_price_qty' : 0,
			'pizaextra_price' : 0,
			'modiferObject' : modifernextdata,
		};
		this.modifersSlected.push(pushModiferArray);
		$('.piza-icons-'+modifer.modifier_id+'-'+modifernextdata.index).show();
		if (modifernextdata.type==='piza') {
			
			let selectedFreeType = "full";
			if (modifernextdata.free!='' && modifernextdata.free!='2' && modifernextdata.free!='3' ) {
				selectedFreeType = modifernextdata.free;
			}
			this.changeModiferSizes(modifernextdata,modifer, selectedFreeType,'');
		}
    } 
	
	//Removed the old selected radio button value
	if ( oldValue!='' || oldValue==0 ){
		console.log(oldValue);
		var qty_sizes:any = 0;
		var free_price:any = 0;
		
		//Getting the Applied Price Sideitems means which are currently selected .
		let appliedprice= this.appliedModifersPrice(modifernextdata, modifer);
		//Getting the Free Price for that modifer
		let freePrice = this.freePriceForModifer(modifernextdata, modifer);

		
		for( var i = 0; i < this.modifersSlected.length; i++){
			if(this.modifersSlected[i].div_id===oldId){
				qty_sizes = this.modifersSlected[i].pizaextra_price*this.modifersSlected[i].pizaextra_price_qty;
				this.modifersSlected.splice(i, 1); 
			}
		}
		
		qty_sizes=parseFloat(this.orderQty)*parseFloat(qty_sizes);
		
		let qty:any = parseFloat(this.orderQty)*parseFloat(oldValue);
		
		var amount=this.submeuGrandPrice-parseFloat(qty);
		amount=amount;
		//this.submeuGrandPrice=amount;
		
		let pizatoppingMinus = appliedprice-freePrice
		
		
		if (pizatoppingMinus>0) {
			this.submeuGrandPrice = this.submeuGrandPrice- pizatoppingMinus;
		}
		 
		//Getting the Applied Price Sideitems means which are currently selected .
					
		let appliedpriceadd= this.appliedModifersPrice(modifernextdata, modifer);
		//Getting the Free Price for that modifer
		let freePriceadd = this.freePriceForModifer(modifernextdata, modifer);
		let pizatoppingadd = appliedpriceadd-freePriceadd;

		//If less then to 0 or in minus then it should be 0 
		if (pizatoppingadd<=0) {
			pizatoppingadd = 0;
		}
		//Mutliplying with the current Main QTY
		var newPrice = pizatoppingadd * parseFloat(this.orderQty);
		//Assing to the Grand Submenu
		this.submeuGrandPrice = this.submeuGrandPrice+newPrice;
		if (qty>0) {
			this.submeuGrandPrice = this.submeuGrandPrice-parseFloat(qty);
		}
		
    }	
	
  }
  
	/* //Updating the Price based on the Modifer QTY Change
	changeModiferSizesQty(modifernextdata:any, modifer, selectedType){
		
		for (var i=0;i<this.modifersSlected.length;i++) {
		
			if (this.modifersSlected[i].id===modifernextdata.index && modifer.modifier_id===this.modifersSlected[i].modifier_id) {
				//removing the old prices
				if (modifernextdata.free==2 && this.modifersSlected[i].pizaextra_price_qty>2) {
				} else if(modifernextdata.free===""){
					var oldToppingPrice = parseFloat(this.modifersSlected[i].pizaextra_price) * parseFloat(this.orderQty);
					oldToppingPrice = oldToppingPrice*this.modifersSlected[i].pizaextra_price_qty;
				}
				
				
				this.submeuGrandPrice = this.submeuGrandPrice-oldToppingPrice;
				
				if (selectedType==='add' && this.modifersSlected[i].pizaextra_price_qty>0 ) {
					if (this.topping_counter_limit>this.modifersSlected[i].pizaextra_price_qty) {
						this.modifersSlected[i].pizaextra_price_qty = this.modifersSlected[i].pizaextra_price_qty+1;
					} 
					
				}else if (selectedType==='minus' && this.modifersSlected[i].pizaextra_price_qty>1) {
					this.modifersSlected[i].pizaextra_price_qty = this.modifersSlected[i].pizaextra_price_qty-1;
				}
				
				//new  price
				var newPrice = parseFloat(this.modifersSlected[i].pizaextra_price) * parseFloat(this.orderQty);
				newPrice = newPrice*this.modifersSlected[i].pizaextra_price_qty;
				
				//Free Price
				let free = 0;
				if (modifernextdata.free==2 && this.modifersSlected[i].pizaextra_price_qty>2) {
					 free = modifernextdata.free * 	this.modifersSlected[i].pizaextra_price;
					 this.submeuGrandPrice = this.submeuGrandPrice+newPrice-free;
				} else if(modifernextdata.free===""){
					this.submeuGrandPrice = this.submeuGrandPrice+newPrice-free;
				}
				console.log(free,newPrice, this.submeuGrandPrice);
				
				
				if (this.modifersSlected[i].pizaextra_price_qty>0) {
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).show();
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('full-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('right-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('left-topping');
					
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).addClass(this.modifersSlected[i].pizaextra_name+'-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).html(this.modifersSlected[i].pizaextra_price_qty);
				}
			}
		}
	} */
	
	appliedModifersPrice (modifernextdata:any, modifer:any) {
		let applied_prices = 0;
		//Loop on all modifers which are selected
		for (var i=0;i<this.modifersSlected.length;i++) {
			//Getting the Current Modifers
			if (this.modifersSlected[i].modifier_id === modifer.modifier_id && this.modifersSlected[i].modiferObject.type==='piza') {
				//Sum the price for applied prices
				let price = this.modifersSlected[i].pizaextra_price_qty*this.modifersSlected[i].pizaextra_price;
				applied_prices = applied_prices+price;
			}
		}
		return applied_prices;
	}
	
	freePriceForModifer (modifernextdata:any, modifer:any) {
		let freePrice = 0;
	
		for (var i =0;i<modifer.data.length;i++) {
			
			//Checking that Which option is seleted
			let hasLeft = $('#circel-icon-left-'+modifer.modifier_id+'-'+modifer.data[i].index).hasClass('fa-circel-icon-selected');
			let hasright = $('#circel-icon-right-'+modifer.modifier_id+'-'+modifer.data[i].index).hasClass('fa-circel-icon-selected');
			let hasfull = $('#circel-icon-full-'+modifer.modifier_id+'-'+modifer.data[i].index).hasClass('fa-circel-icon-selected');
					
			//Checking that Free Type for now i just worked on 2 and 3 left rigth whole is not done 
			if (modifer.data[i].free==='2' || modifer.data[i].free==='3') {
				
				if (modifer.data[i].free_prices) {
					//Checking the size for now i have just checked the small
					if (this.slectedMenuSize === 'Small') {
						//Checking which one is slected according to this gett the free price which is coming from api reposnse get modifer list
						if (hasfull == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_full_free);
						}else if (hasLeft == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_left_free);
						}else if (hasright == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_right_free);
						} else {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_full_free);
						}
					} else if ( this.slectedMenuSize === 'Medium' ) {
						
						if (hasfull == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_full_free);
						}else if (hasLeft == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_left_free);
						}else if (hasright == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_right_free);
						} else {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_full_free);
						}
					} else if ( this.slectedMenuSize === 'Large' ) {
						
						if (hasfull == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_full_free);
						}else if (hasLeft == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_left_free);
						}else if (hasright == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_right_free);
						} else {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_full_free);
						}
						
					} else if ( this.slectedMenuSize === 'Ex Large' ) {
						
						if (hasfull == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.ex_large_full_free);
						}else if (hasLeft == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.ex_large_left_free);
						}else if (hasright == true) {
							freePrice = freePrice+parseFloat(modifer.data[i].free_prices.ex_large_right_free);
						} else {
							freePrice = freePrice+ parseFloat(modifer.data[i].free_prices.ex_large_full_free);
						}
						
					}
				}
			} else if (modifer.data[i].free==='left') {
				if (this.slectedMenuSize === 'Small') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_left_free);
				}else if (this.slectedMenuSize === 'Medium') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_left_free);
				}else if (this.slectedMenuSize === 'Large') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_left_free);
				}else if (this.slectedMenuSize === 'Ex Large') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.ex_large_left_free);
				}
			} else if (modifer.data[i].free==='full') {
				if (this.slectedMenuSize === 'Small') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_full_free);
				}else if (this.slectedMenuSize === 'Medium') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_full_free);
				}else if (this.slectedMenuSize === 'Large') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_full_free);
				}else if (this.slectedMenuSize === 'Ex Large') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.ex_large_full_free);
				}
			} else if (modifer.data[i].free==='right') {
				if (this.slectedMenuSize === 'Small') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.small_right_free);
				}else if (this.slectedMenuSize === 'Medium') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.medium_right_free);
				}else if (this.slectedMenuSize === 'Large') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.large_right_free);
				}else if (this.slectedMenuSize === 'Ex Large') {
					freePrice = freePrice+parseFloat(modifer.data[i].free_prices.ex_large_right_free);
				}
			}
			
		}
		return freePrice;
	}
	
	//Updating the Price based on the Modifer QTY Change
	changeModiferSizesQty(modifernextdata:any, modifer, selectedType, callfrom){

		for (var i=0;i<this.modifersSlected.length;i++) {
		
			if (this.modifersSlected[i].id===modifernextdata.index && modifer.modifier_id===this.modifersSlected[i].modifier_id ) {
			
				
			 	if (parseInt(this.topping_counter_limit)<=this.modifersSlected[i].pizaextra_price_qty && selectedType==='add' ) {
					continue;
				}
				
				/*if (this.modifersSlected[i].free==2 && this.modifersSlected[i].pizaextra_price_qty<=2) {
					
				}else if (this.modifersSlected[i].free==3 && this.modifersSlected[i].pizaextra_price_qty<=3) {
					
				} else {
					let freeprice = 0;
					//checking the free
					if (this.modifersSlected[i].free==2) {
						freeprice = this.modifersSlected[i].pizaextra_price*2;
						freeprice = freeprice* parseFloat(this.orderQty);
					}else if (this.modifersSlected[i].free==3) {
						freeprice = this.modifersSlected[i].pizaextra_price*3;
						freeprice = freeprice* parseFloat(this.orderQty);
					}
					
					//removing the old prices
					var oldToppingPrice = parseFloat(this.modifersSlected[i].pizaextra_price) * parseFloat(this.orderQty);
					oldToppingPrice = oldToppingPrice* ( this.modifersSlected[i].pizaextra_price_qty );
					let oldPriceTopping  = oldToppingPrice-freeprice;
					this.submeuGrandPrice = this.submeuGrandPrice-oldPriceTopping;
					
				} */
				
				//removing the old prices
				
				if (callfrom!='api') {
					//Getting the Applied Modifers Prices
					let appliedprice= this.appliedModifersPrice(modifernextdata, modifer);
					//Getting the Free Modifers Prices
					let freePrice = this.freePriceForModifer(modifernextdata, modifer);
					let pizatoppingMinus = appliedprice-freePrice
					if (pizatoppingMinus>0) {
						var newPrice = pizatoppingMinus * parseFloat(this.orderQty);
						this.submeuGrandPrice = this.submeuGrandPrice- newPrice;
					}
				}
				
				if (selectedType==='add' && this.modifersSlected[i].pizaextra_price_qty>0) {
					this.modifersSlected[i].pizaextra_price_qty = this.modifersSlected[i].pizaextra_price_qty+1;
				}else if (selectedType==='minus' && this.modifersSlected[i].pizaextra_price_qty>1) {
					this.modifersSlected[i].pizaextra_price_qty = this.modifersSlected[i].pizaextra_price_qty-1;
				}
				
				/* if (this.modifersSlected[i].free==2 && this.modifersSlected[i].pizaextra_price_qty<=2) {
					
				}else if (this.modifersSlected[i].free==3 && this.modifersSlected[i].pizaextra_price_qty<=3) {
					
				} else { 
					//new  price
					var newPrice = parseFloat(this.modifersSlected[i].pizaextra_price) * parseFloat(this.orderQty);
					newPrice = newPrice*this.modifersSlected[i].pizaextra_price_qty;
					this.submeuGrandPrice = this.submeuGrandPrice+newPrice;
				} */
				
				//new  price
				
					
				
				/* //Checking the Free Qty 
				if (this.modifersSlected[i].free==2 && this.modifersSlected[i].pizaextra_price_qty>2) {
					//let remaingQty = this.modifersSlected[i].pizaextra_price_qty - 2;
					let freePrice = this.modifersSlected[i].pizaextra_price*2;
					freePrice = freePrice* parseFloat(this.orderQty);
					this.submeuGrandPrice = this.submeuGrandPrice - freePrice;
				}else if (this.modifersSlected[i].free==3 && this.modifersSlected[i].pizaextra_price_qty>3) {
					let freePrice = this.modifersSlected[i].pizaextra_price*3;
					freePrice = freePrice* parseFloat(this.orderQty);
					this.submeuGrandPrice = this.submeuGrandPrice - freePrice;
				} */
				
				
				if (this.modifersSlected[i].pizaextra_price_qty>0) {
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).show();
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('full-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('right-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('left-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).addClass(this.modifersSlected[i].pizaextra_name+'-topping');
					$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).html(this.modifersSlected[i].pizaextra_price_qty);
				}
				
				
				if (callfrom!='api') {
						
						//Getting the Applied Price Sideitems means which are currently selected .
						
						let appliedprice= this.appliedModifersPrice(modifernextdata, modifer);
						//Getting the Free Price for that modifer
						let freePrice = this.freePriceForModifer(modifernextdata, modifer);
						let pizatopping = appliedprice-freePrice;
						//If less then to 0 or in minus then it should be 0 
						if (pizatopping<=0) {
							pizatopping = 0;
						}
						//Mutliplying with the current Main QTY
						var newPrice = pizatopping * parseFloat(this.orderQty);
						//Assing to the Grand Submenu
						this.submeuGrandPrice = this.submeuGrandPrice+newPrice;
					
				}
				
			}
		}
	}
	
	changeModiferSizes(modifernextdata:any,modifer:any, selectedType, callfrom){
		
		//Getting the Price and label
		let pizaExtra:any = this.getPizaTypeExtraPriceAndLabel(modifernextdata, selectedType);
		let selectedModifer:any = [] ;
		let minus_free = 0;
		let freeprice = 0;
		
		var left = $('#circel-icon-left-'+modifer.modifier_id+'-'+modifernextdata.index).hasClass('fa-circel-icon-selected');
		var full = $('#circel-icon-full-'+modifer.modifier_id+'-'+modifernextdata.index).hasClass('fa-circel-icon-selected');
		var right = $('#circel-icon-right-'+modifer.modifier_id+'-'+modifernextdata.index).hasClass('fa-circel-icon-selected');
		if (left == true && selectedType==='left') {
			return ;
		}
		if (full == true && selectedType==='full') {
			return ;
		}
		if (right == true && selectedType==='right') {
			return ;
		}
		
		
		if (callfrom!='api') {
			//Getting the Applied Modifers Prices
			let appliedprice= this.appliedModifersPrice(modifernextdata, modifer);
			//Getting the Free Modifers Prices
			let freePrice = this.freePriceForModifer(modifernextdata, modifer);
			
			appliedprice = appliedprice* parseFloat(this.orderQty);
			freePrice = freePrice* parseFloat(this.orderQty);
			
			let pizatoppingMinus = appliedprice-freePrice;
			if (pizatoppingMinus>0) {
			
				this.submeuGrandPrice = this.submeuGrandPrice- pizatoppingMinus;
			}
		}
		
		//Removing from the array
		for (var i=0;i<this.modifersSlected.length;i++) {
			if (this.modifersSlected[i].id==modifernextdata.index && modifer.modifier_id==this.modifersSlected[i].modifier_id) {
				selectedModifer = this.modifersSlected[i];
				this.modifersSlected.splice(i, 1);
			}
		}
		
		

		
		$('#circel-icon-left-'+selectedModifer.modifier_id+'-'+selectedModifer.id).removeClass('fa-circel-icon-selected');
		$('#circel-icon-full-'+selectedModifer.modifier_id+'-'+selectedModifer.id).removeClass('fa-circel-icon-selected');
		$('#circel-icon-right-'+selectedModifer.modifier_id+'-'+selectedModifer.id).removeClass('fa-circel-icon-selected');
		$('.piza-top-counter-'+modifer.modifier_id+'-'+selectedModifer.id).hide();
			
		//If exist then push again after Changing the price and calulcation
		if(selectedModifer.id) {
			var pushModiferArray={
				'id': selectedModifer.id,
				'code': selectedModifer.code,
				'modifier_id': selectedModifer.modifier_id,
				'name': selectedModifer.name,
				'modifier_sequence': selectedModifer.modifier_sequence,
				'div_id': selectedModifer.div_id,
				'amount' : selectedModifer.amount,
				'free' : selectedModifer.free,
				'pizaextra_name' : pizaExtra.pizaextra_name,
				'pizaextra_price_qty' : 1,
				'pizaextra_price' : parseFloat(pizaExtra.selectedSizePrice),
				'modiferObject' : selectedModifer.modiferObject,
			};
			
			this.modifersSlected.push(pushModiferArray);
			if (callfrom!='api') {
				setTimeout(() => {
					let addappliedprice= this.appliedModifersPrice(modifernextdata, modifer);
					//Getting the Free Price for that modifer
					let addfreePrice = this.freePriceForModifer(modifernextdata, modifer);
					let addpizatopping = addappliedprice-addfreePrice;
					
					//If less then to 0 or in minus then it should be 0 
					if (addpizatopping<=0) {
						addpizatopping = 0;
					}
					//Mutliplying with the current Main QTY
					var newPrice = addpizatopping * parseFloat(this.orderQty);
					//Assing to the Grand Submenu
					this.submeuGrandPrice = this.submeuGrandPrice+newPrice;
				}, 10);
				
			}
			
			$('#circel-icon-'+selectedType+'-'+selectedModifer.modifier_id+'-'+selectedModifer.id).addClass('fa-circel-icon-selected');
		}
		
	}	
	
	//returing the size price and its size
	getPizaTypeExtraPriceAndLabel (modifernextdata, selectedType) {
		var selectedSizePrice = 0;
		var pizaextra_name = "";
		if (modifernextdata.type==='piza') {
			//In Case of Small Size Selected
			if (this.slectedMenuSize==='Small') {
				if (modifernextdata.small_left>=0 && selectedType==='left') {
					selectedSizePrice = modifernextdata.small_left;
					pizaextra_name = "left";
				}else if (modifernextdata.small_right>=0 && selectedType==='right') {
					selectedSizePrice = modifernextdata.small_right;
					pizaextra_name = "right";
				}else if (modifernextdata.small_right>=0 && selectedType==='full') {
					selectedSizePrice = modifernextdata.small_full;
					pizaextra_name = "full";
				}
			}
			
			if (this.slectedMenuSize==='Medium') {
				if (modifernextdata.medium_left>=0 && selectedType==='left') {
					selectedSizePrice = modifernextdata.medium_left;
					pizaextra_name = "left";
				}else if (modifernextdata.medium_right>=0 && selectedType==='right') {
					selectedSizePrice = modifernextdata.medium_right;
					pizaextra_name = "right";
				}else if (modifernextdata.medium_full>=0 && selectedType==='full') {
					selectedSizePrice = modifernextdata.medium_full;
					pizaextra_name = "full";
				}
			}
			
			if (this.slectedMenuSize==='Large') {
				if (modifernextdata.large_left>=0 && selectedType==='left') {
					selectedSizePrice = modifernextdata.large_left;
					pizaextra_name = "left";
				}else if (modifernextdata.large_right>=0 && selectedType==='right') {
					selectedSizePrice = modifernextdata.large_right;
					pizaextra_name = "right";
				}else if (modifernextdata.large_full>=0 && selectedType==='full') {
					selectedSizePrice = modifernextdata.large_full;
					pizaextra_name = "full";
				}
			}
			
			if (this.slectedMenuSize==='Ex Large') {
				if (modifernextdata.ex_large_left>=0 && selectedType==='left') {
					selectedSizePrice = modifernextdata.ex_large_left;
					pizaextra_name = "left";
				}else if (modifernextdata.ex_large_right>=0 && selectedType==='right') {
					selectedSizePrice = modifernextdata.ex_large_right;
					pizaextra_name = "right";
				}else if (modifernextdata.ex_large_full>=0 && selectedType==='full') {
					selectedSizePrice = modifernextdata.ex_large_full;
					pizaextra_name = "full";
				}
			}
			
		}
		let returnData = {
			selectedSizePrice: selectedSizePrice,
			pizaextra_name: pizaextra_name,
		};
		return returnData ;
	}
	
	selectthebyDefaultModifers (  modifernextdata, modifer ,type, index) 
	{
		if (type==='checkbox' ){ 
			let eve = [];
			eve['target']= {
				'value':modifernextdata.amount,
				'checked':true,
				'id': 'regularDough_'+modifer.modifier_id+'_'+modifernextdata.index
			};
			
			if (modifernextdata.free!='') {
				$( "#regularDough_"+modifer.modifier_id+'_'+modifernextdata.index ).prop( "checked", true );
				this.onCheckboxChange (eve, modifernextdata, modifer, 'api');
			}
		} else if (type==='radio') {
			let eve = [];
			eve['target']= {
				'checked':true,
				'id': 'regular_'+modifer.modifier_id+'_'+modifernextdata.index,
				'name': 'radio_'+index+'_'+modifer.modifier_id,
				'value': modifernextdata.amount
			};
			this.onRadioButtonChange(eve,modifernextdata,modifer)
		}
		return "";
	}
	
	//price changed on the checkbox change
	onCheckboxChange(eve: any,modifernextdata:any,modifer:any, callfrom){
		//Getting the Applied Price Sideitems means which are currently selected .
		let appliedprice= this.appliedModifersPrice(modifernextdata, modifer);
		//Getting the Free Price for that modifer
		let freePrice = this.freePriceForModifer(modifernextdata, modifer);
		
		//For Piza Topping And Extra
		$('#circel-icon-left-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('fa-circel-icon-selected');
		$('#circel-icon-full-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('fa-circel-icon-selected');
		$('#circel-icon-right-'+modifer.modifier_id+'-'+modifernextdata.index).removeClass('fa-circel-icon-selected');
		let pizaExtra:any = this.getPizaTypeExtraPriceAndLabel(modifernextdata, 'left');
		if (modifernextdata.type==='piza') {
			eve.target.value = 0;
		}
		
		var qty=parseFloat(this.orderQty)*parseFloat(eve.target.value);
		if (eve.target.checked) {
			var amount=qty+this.submeuGrandPrice;
			amount=amount;
			this.submeuGrandPrice=amount;
			
			var pushModiferArray={
				'id': modifernextdata.index,
				'code': modifernextdata.code,
				'modifier_id': modifer.modifier_id,
				'name': modifernextdata.modifier_name,
				'modifier_sequence': modifer.modifier_sequence,
				'free': modifernextdata.free,
				'div_id': eve.target.id,
				'amount' : eve.target.value,
				'pizaextra_name' : '',
				'pizaextra_price_qty' : 0,
				'pizaextra_price' : 0,
				'modiferObject' : modifernextdata,
			};
			
			this.modifersSlected.push(pushModiferArray);
			$('.piza-icons-'+modifer.modifier_id+'-'+modifernextdata.index).show();
			
			if (modifernextdata.type==='piza') {
				let selectedFreeType = "full";
				if (modifernextdata.free!='' && modifernextdata.free!='2' && modifernextdata.free!='3' ) {
					selectedFreeType = modifernextdata.free;
				}
				
				this.changeModiferSizes(modifernextdata,modifer, selectedFreeType, callfrom);
			}
			
		} else {
			$('.piza-icons-'+modifer.modifier_id+'-'+modifernextdata.index).hide();
			$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).hide();
			$('.piza-top-counter-'+modifer.modifier_id+'-'+modifernextdata.index).html('');
			var qty_sizes:any = 0;
			var free_price:any = 0;
			
			console.log(appliedprice, "appliedprice");
			console.log(freePrice, "freePrice");
			
			for( var i = 0; i < this.modifersSlected.length; i++){
				if(this.modifersSlected[i].div_id===eve.target.id){
					qty_sizes = this.modifersSlected[i].pizaextra_price*this.modifersSlected[i].pizaextra_price_qty;
					this.modifersSlected.splice(i, 1);
				}
			}
			qty_sizes=parseFloat(this.orderQty)*parseFloat(qty_sizes);
			
			//Getting the Free Modifers Prices
			appliedprice = appliedprice * parseFloat(this.orderQty);
			freePrice = freePrice * parseFloat(this.orderQty);
			
			
			let pizatoppingMinus = appliedprice-freePrice
			if (pizatoppingMinus>0) {
				this.submeuGrandPrice = this.submeuGrandPrice- pizatoppingMinus;
			}
			setTimeout(() => {
				//Now adding the topping price 
				//Getting the Applied Price Sideitems means which are currently selected .
							
				let appliedpriceadd= this.appliedModifersPrice(modifernextdata, modifer);
				//Getting the Free Price for that modifer
				let freePriceadd = this.freePriceForModifer(modifernextdata, modifer);
				
				let pizatoppingadd = appliedpriceadd-freePriceadd;
				
				//If less then to 0 or in minus then it should be 0 
				if (pizatoppingadd<=0) {
					pizatoppingadd = 0;
				}
				//Mutliplying with the current Main QTY
				var newPrice = pizatoppingadd * parseFloat(this.orderQty);
				//Assing to the Grand Submenu
				this.submeuGrandPrice = this.submeuGrandPrice+newPrice;
				
				this.submeuGrandPrice = this.submeuGrandPrice -qty;
				
				return ;
			}, 10);
			
			
			/* var amount=this.submeuGrandPrice-qty_sizes;
			amount=amount; 
			this.submeuGrandPrice=amount; */
			
			
		}
	
	}
  
	changeQuatity(){
		if ($('.qtyvalue').val()<1) {
			$('.qtyvalue').val(1);
		}
		this.oldSubmeuGrandPrice=this.submeuGrandPrice/parseFloat(this.orderQty);

		this.orderQty = $('.qtyvalue').val();
		this.submeuGrandPrice=parseFloat(this.orderQty)*this.oldSubmeuGrandPrice;

		
	}
	//function is used to update the qutatinty 
	updateQuatity(type){
		this.oldSubmeuGrandPrice=this.submeuGrandPrice/parseFloat(this.orderQty);
		if(type==='add'){
			this.orderQty++;
		}else{
			if(this.orderQty!=1){
				this.orderQty--;
			}
		}
		this.submeuGrandPrice=parseFloat(this.orderQty)*this.oldSubmeuGrandPrice;
	}
  
  substitutedPrice () {
	let substitutedArray = [];
	for (var j=0;j<this.modifersData.length;j++){
		
		for (var i=0;i<this.modifersData[j]['data'].length;i++) {
			var sideItem = this.modifersData[j]['data'][i];
			let freePrice:any = "";
			if (sideItem.free!='') {
				var hasLeft = $('#circel-icon-left-'+this.modifersData[j].modifier_id+'-'+sideItem.index).hasClass('fa-circel-icon-selected');
				var hasright = $('#circel-icon-right-'+this.modifersData[j].modifier_id+'-'+sideItem.index).hasClass('fa-circel-icon-selected');
				var hasfull = $('#circel-icon-full-'+this.modifersData[j].modifier_id+'-'+sideItem.index).hasClass('fa-circel-icon-selected');
				
				if (sideItem.free==='2' || sideItem.free==='3') {
				if (this.slectedMenuSize === 'Small') {
					//Checking which one is slected according to this gett the free price which is coming from api reposnse get modifer list
					if (hasfull == true) {
						freePrice = parseFloat(sideItem.free_prices.small_full_free);
					}else if (hasLeft == true) {
						freePrice = parseFloat(sideItem.free_prices.small_left_free);
					}else if (hasright == true) {
						freePrice = parseFloat(sideItem.free_prices.small_right_free);
					} else {
						freePrice = parseFloat(sideItem.free_prices.small_full_free);
					}
				} else if ( this.slectedMenuSize === 'Medium' ) {
					
					if (hasfull == true) {
						freePrice = freePrice+parseFloat(sideItem.free_prices.medium_full_free);
					}else if (hasLeft == true) {
						freePrice = parseFloat(sideItem.free_prices.medium_left_free);
					}else if (hasright == true) {
						freePrice = parseFloat(sideItem.free_prices.medium_right_free);
					} else {
						freePrice = parseFloat(sideItem.free_prices.medium_full_free);
					}
				} else if ( this.slectedMenuSize === 'Large' ) {
					
					if (hasfull == true) {
						freePrice = parseFloat(sideItem.free_prices.large_full_free);
					}else if (hasLeft == true) {
						freePrice = parseFloat(sideItem.free_prices.large_left_free);
					}else if (hasright == true) {
						freePrice = parseFloat(sideItem.free_prices.large_right_free);
					} else {
						freePrice = parseFloat(sideItem.free_prices.large_full_free);
					}
					
				} else if ( this.slectedMenuSize === 'Ex Large' ) {
					
					if (hasfull == true) {
						freePrice = parseFloat(sideItem.free_prices.ex_large_full_free);
					}else if (hasLeft == true) {
						freePrice = parseFloat(sideItem.free_prices.ex_large_left_free);
					}else if (hasright == true) {
						freePrice = parseFloat(sideItem.free_prices.ex_large_right_free);
					} else {
						freePrice =  parseFloat(sideItem.free_prices.ex_large_full_free);
					}
					
				}
				}else if (sideItem.free==='left') {
					if (this.slectedMenuSize === 'Small') {
						freePrice = parseFloat(sideItem.free_prices.small_left_free);
					}else if (this.slectedMenuSize === 'Medium') {
						freePrice = parseFloat(sideItem.free_prices.medium_left_free);
					}else if (this.slectedMenuSize === 'Large') {
						freePrice = parseFloat(sideItem.free_prices.large_left_free);
					}else if (this.slectedMenuSize === 'Ex Large') {
						freePrice = parseFloat(sideItem.free_prices.ex_large_left_free);
					}
				} else if (sideItem.free==='full') {
					if (this.slectedMenuSize === 'Small') {
						freePrice = parseFloat(sideItem.free_prices.small_full_free);
					}else if (this.slectedMenuSize === 'Medium') {
						freePrice = parseFloat(sideItem.free_prices.medium_full_free);
					}else if (this.slectedMenuSize === 'Large') {
						freePrice = parseFloat(sideItem.free_prices.large_full_free);
					}else if (this.slectedMenuSize === 'Ex Large') {
						freePrice = parseFloat(sideItem.free_prices.ex_large_full_free);
					}
				} else if (sideItem.free==='right') {
					if (this.slectedMenuSize === 'Small') {
						freePrice = parseFloat(sideItem.free_prices.small_right_free);
					}else if (this.slectedMenuSize === 'Medium') {
						freePrice = parseFloat(sideItem.free_prices.medium_right_free);
					}else if (this.slectedMenuSize === 'Large') {
						freePrice = parseFloat(sideItem.free_prices.large_right_free);
					}else if (this.slectedMenuSize === 'Ex Large') {
						freePrice = parseFloat(sideItem.free_prices.ex_large_right_free);
					}
				}
				
				let is_apply:any = 0;
				var div_id = "";
				for (var k=0;k<this.modifersSlected.length;k++){
					if (this.modifersSlected[k].modifier_id == this.modifersData[j].modifier_id &&
					sideItem.index==this.modifersSlected[k].id) {
						is_apply = $('#'+this.modifersSlected[k].div_id).is(':checked');
						if (is_apply == true) {
							is_apply= 1;
						} else {
							is_apply = 0;
						}
						
						div_id = this.modifersSlected[k].div_id;
					}
				}
				substitutedArray.push({
					'code':sideItem.code,
					'name':sideItem.modifier_name,
					'free':sideItem.free,
					'free_price':freePrice,
					'is_apply':is_apply,
					'div_id':div_id,
					'id':sideItem.index,
					'modifier_id':this.modifersData[j].modifier_id,
				});
			}
			
		}
		
	}
	return substitutedArray;
  }
  
	//Function is used to merge the subsituite 
	mergeSubstituted (addOns, substitutedArray) {
		for (var i=0;i<substitutedArray.length;i++) {
			if (substitutedArray[i].is_apply== 0) {
				var addNewOdon = {
					"amount": "0",
					"div_id": "",
					"code": substitutedArray[i].code,
					"id": substitutedArray[i].id,
					"modifier_id": substitutedArray[i].modifier_id,
					"modifier_sequence": "0",
					"name": "No "+substitutedArray[i].name,
					"pizaextra_name": "",
					"pizaextra_price": '',
					"pizaextra_price_qty": '',
					"free": ""
				};
				addOns.unshift(addNewOdon);
			}
		}
		return addOns;
	}
  
	//Function is used to saved the order Submenu on local Storage
	subMenuOrderSave(){
	 let substitutedArray :any= this.substitutedPrice();
	 
	//Loop for validations of addons 
	this.bookOrderValidationMessage='';
		for (var j=0;j<this.modifersData.length;j++){
			if(this.modifersData[j].modifier_mandatory==='1'){
				var checkedClass=".modifier_mandatory_"+this.modifersData[j].modifier_id;
				if(!$(checkedClass).is(':checked')) { 
					this.bookOrderValidationMessage+="'"+this.modifersData[j].modifier_heading+"',";
				}
			}
		}
	this.bookOrderValidationMessage = this.bookOrderValidationMessage.slice(0, -1)

	if(this.subMeuData.id && this.bookOrderValidationMessage===''){
		if(this.subMeuData.dealData){
			this.itemType = 'D';
		} else {
			this.itemType = 'M';
		}
		
		for (var cm=0;cm<this.modifersData.length;cm++) {
			 var  appliedprice:any = this.appliedModifersPrice(this.modifersData[cm],this.modifersData[cm]);
			 var freePrice:any = this.freePriceForModifer (this.modifersData[cm],this.modifersData[cm]);
			 var remainprice:any = parseFloat(appliedprice) - parseFloat(freePrice);
			 if (remainprice<0) {
				remainprice = 0;
			 } 
			 this.modifersData[cm].freePrice  = freePrice;
		}
		
		
		//setting the addons
		var addOns = [];
		for (var i=0;i<this.modifersSlected.length;i++) {
			let pizaextra_price = this.modifersSlected[i].pizaextra_price*this.modifersSlected[i].pizaextra_price_qty;
			for (var cm=0;cm<this.modifersData.length;cm++) {
				 if (this.modifersSlected[i].modifier_id === this.modifersData[cm].modifier_id) {
					let oldfreePrice = this.modifersData[cm].freePrice;
					let getPizaExtra = pizaextra_price - oldfreePrice  
					this.modifersData[cm].freePrice = this.modifersData[cm].freePrice - pizaextra_price;
					pizaextra_price = getPizaExtra;
					
					if (pizaextra_price<0) {
						pizaextra_price = 0;
					
					}
					if (this.modifersData[cm].freePrice<0) {
						this.modifersData[cm].freePrice = 0;
					}
				 }
				 
				 /* if (this.modifersSlected[i].modifier_id === this.modifersData[cm].modifier_id) {
					let oldRemaing = this.modifersData[cm].remaining;
					console.log(oldRemaing, oldRemaing);
					let getPizaExtra = pizaextra_price - this.modifersData[cm].remaining;
					
					this.modifersData[cm].remaining = this.modifersData[cm].remaining -getPizaExtra;
					if (this.modifersData[cm].remaining<0) {
						this.modifersData[cm].remaining = 0;
					}
					
					if (getPizaExtra < 0 ) {
						pizaextra_price = 0;
					} else {
						pizaextra_price =getPizaExtra;
					}
					
				 } */
			}
			
			/* let freeQty = 0;
			if (this.modifersSlected[i].free === 'left' ||this.modifersSlected[i].free === 'right' || this.modifersSlected[i].free === 'full' &&  this.modifersSlected[i].free>1) {
				freeQty = 1;
			}else if (this.modifersSlected[i].free == 2 &&  this.modifersSlected[i].free>=2) {
				freeQty = 2;
			}else if (this.modifersSlected[i].free == 3 &&  this.modifersSlected[i].free>=3) {
				freeQty = 3;
			} 
			let freeprice = this.modifersSlected[i].pizaextra_price*freeQty; 
			pizaextra_price = pizaextra_price-freeprice;	
			*/
			
			
			addOns.push({
				"amount":this.modifersSlected[i].amount,
				"code":this.modifersSlected[i].code,
				"div_id":this.modifersSlected[i].div_id,
				"id":this.modifersSlected[i].id,
				"modifier_id":this.modifersSlected[i].modifier_id,
				"modifier_sequence":this.modifersSlected[i].modifier_sequence,
				"name":this.modifersSlected[i].name,
				"pizaextra_name":this.modifersSlected[i].pizaextra_name,
				"pizaextra_price":pizaextra_price,
				"pizaextra_price_qty":this.modifersSlected[i].pizaextra_price_qty,
				"free":this.modifersSlected[i].free,
			});
		}
	
		
		addOns = this.mergeSubstituted (addOns, substitutedArray);
		
		if (this.itemType==='D') {
			addOns = this.modifersSlected;
		}
		
		var finalAddon = [];
		//Cleans addon data
		for (var i=0;i<addOns.length;i++) {
			finalAddon.push({
					"amount":addOns[i].amount,
					"code":addOns[i].code,
					"id":addOns[i].id,
					"modifier_id":addOns[i].modifier_id,
					"modifier_sequence":addOns[i].modifier_sequence,
					"name":addOns[i].name,
					"pizaextra_name":addOns[i].pizaextra_name,
					"pizaextra_price":addOns[i].pizaextra_price,
					"pizaextra_price_qty":addOns[i].pizaextra_price_qty,
					"free":addOns[i].free,
				});
		}
		
		var size_display_name = '';
		for ( var size=0;size<this.subMeuSizes.length;size++) {
			if (this.subMeuSizes[size].size === this.slectedMenuSize ) {
				size_display_name = this.subMeuSizes[size].size_display_name;
				
			}
		}
		
		if (this.subMeuData.type!="piza" ) {
			size_display_name = this.slectedMenuSize;
		}
		var currentdatetime = new Date()
		var dataTostore={
			"submenuImage":this.subMeuData.image,
			"station_id":this.subMeuData.station,
			"ItemId":this.subMeuData.id,
			"ItemQty":this.orderQty,
			"ItemAmt":this.submeuGrandPrice,
			"ItemBasePrice":this.ItemBasePrice,
			
			"ItemType": this.itemType,
			"ItemInstructions": $('#special_instruction').val(),
			"ItemSize": this.slectedMenuSize,
			"ItemSizeDisplayName": size_display_name,
			"SizeId": this.slectedMenuSizeIndex,
			"addOns": finalAddon,
			//"substitutedaddOns": substitutedArray,
			"subMeuName": this.subMeuName,
			"date":currentdatetime.toString()
		};
		

		
		var orderData=localStorage.getItem('orderData');
		if(orderData!=null){
			orderData = JSON.parse(orderData);
			if(Array.isArray(orderData)){
				orderData.push(dataTostore);
				localStorage.setItem('orderData', JSON.stringify(orderData));
			}
			
		}else{
			var data=[];
			data.push(dataTostore);
			localStorage.setItem('orderData', JSON.stringify(data));
		}
	localStorage.removeItem('iscouponApplied');
	localStorage.removeItem('couponData');

	$('#customizeModal').modal('hide');
	} 
	this.cartModeldata();	
  }
  
  //Load the cart modal data
  cartModeldata(){
	var orderData=localStorage.getItem('orderData');
	if(localStorage.getItem('isLogin')!=null){
		this.isLogin=localStorage.getItem('isLogin');
	}
	var service_type=localStorage.getItem('service_type');
	if(orderData!=null){
		this.is_d_error = '0';
		this.cartModelData=JSON.parse(orderData);
		$('.cart-item-count').html(this.cartModelData.length);
		
		this.cartTotalBalance=this.getTotalCartAmount(this.cartModelData);
		const server_cal_object = new FormData();
		server_cal_object.append( 'res_id', '49');
		server_cal_object.append( 'subtotal', this.cartTotalBalance);
		server_cal_object.append( 'is_tax_res_not_applied', '');
		server_cal_object.append( 'service_type', this.selectedOrderServiceType);
		
		this._http.postRequest('server_side_taxcal.php',server_cal_object).subscribe((data: any) => {
			this.is_d_error = '1';
			if (data.data.totalamount) {
				this.cartTotalBalance = data.data.totalamount;
			}
			if(this.cartModelData.length>0){
				this.isCartData='1';
			}else{
				this.isCartData='0';
			}
			if(data.error_type) {
				if (data.error_type ==='delivery') {
					this.is_d_error = '1';
					this.notifyService.showError(data.message, "Error ..!!");
					this.selectedOrderServiceType = '';
					localStorage.setItem('selectedOrderService', '');
					this.eventBus.cast('error:delivery','delivery');

				}
			}
			this.eventBus.cast('server:cal','servercal');

		}); 
		
		
		
	}else{
		this.isCartData='0';
	}
	if(service_type!=null && service_type!=''){
		this.cartModelService = service_type.split(','); // split string on comma space
		if (this.cartModelService.length==1 && (this.selectedOrderServiceType==='' || this.selectedOrderServiceType==null)) {
			localStorage.setItem('selectedOrderService', this.cartModelService[0]);
			localStorage.removeItem('deliveryAddress');
			this.selectedOrderServiceType=this.cartModelService[0];
			
		}
	}
  }
  
  //Get the total amount from cart
  getTotalCartAmount(cartData){
	var total_amount=0;
	for (var i=0;i<cartData.length;i++){
		total_amount=total_amount+cartData[i].ItemAmt;
	}
	return total_amount;		

  }
  
  //Are used to delete the item from cart
  deleteItemFromCart(index){
    var orderData=localStorage.getItem('orderData');
	if(orderData!=null){
		for (var i=0;i<this.cartModelData.length;i++){
			if(index==i){
				this.cartModelData.splice(i, 1); 

			}
		}
		localStorage.setItem('orderData', JSON.stringify(this.cartModelData));
		this.cartModeldata();
	}
  }
  
  //Are used update the cart image url 
  cartErrorUpdateUrl(result){
	var cart_image='cart_image_'+result;
	(document.getElementById(cart_image) as HTMLImageElement).src = 'assets/img/prods-sm/5-new.png';
  }
  
  //Are used to update the service type 
  selectedOrderService(selectedOrderService){
	localStorage.setItem('selectedOrderService', selectedOrderService);
	localStorage.removeItem('deliveryAddress');
	//$('.cart-trigger').prop('disabled', true);
	setTimeout(() => {
		this.cartModeldata();
	}, 500);
	this.selectedOrderServiceType=selectedOrderService;
	if (this.router.url==='/locations' && selectedOrderService!='Delivery') {
		localStorage.setItem('reloadFrom', 'location');
		setTimeout(() => {
			location.reload();
		}, 500);
	}
  }
  
  //Are used to clear all cart data
  deleteWholeCartData(type)
  {
	if(type==='all'){
		localStorage.removeItem("orderData");
		localStorage.removeItem("selectedOrderService");
	}
	this.cartModeldata();

  }
  //This is triger on the time picker change 
	changed(): void {

	}
	
	updateMaxMinTime () {
		var selectedDate = this.datePipe.transform(this.orderDateSelected, 'EEEE, MMMM d');
		var today = this.datePipe.transform(Date(), 'EEEE, MMMM d');
		if (selectedDate!=today) {
			this.minTime.setHours(0);
			this.minTime.setMinutes(0);
			this.maxTime.setHours(23);
			this.maxTime.setMinutes(59);
		} else {
			var currentDate = new Date();
			
			if (this.mytime<currentDate) {
				this.mytime = new Date();
			} 
			var hours = this.datePipe.transform(currentDate, 'H');
			var min = this.datePipe.transform(currentDate, 'm');
			this.minTime.setHours(parseInt(hours));
			this.minTime.setMinutes(parseInt(min));
			this.maxTime.setHours(23);
			this.maxTime.setMinutes(59);
			
		} 
	}
	datepickerChange ($event) {
		this.updateMaxMinTime();
	}
	updateDateTime () {
	this.updateMaxMinTime();
	
	var time=this.mytime;

	localStorage.setItem("orderDatetime", time);
	localStorage.setItem("orderDate", this.orderDateSelected);
	localStorage.setItem("isOrderDateTimeChange", '1');
	var timeSelected = this.datePipe.transform(this.mytime, 'h:mm a');
	var dateSelected = this.datePipe.transform(this.orderDateSelected, 'EEEE, MMMM d ');
	this.myCartDateTime=dateSelected+timeSelected;
	this.sharedService.nextOrderDateCart(this.myCartDateTime);
	if (this.router.url==='/locations' ) {
		localStorage.setItem('reloadFrom', 'location');
		setTimeout(() => {
			location.reload();
		}, 500);
	}
	if (this.router.url==='/checkout' ) {
		this.router.navigateByUrl('/locations');
	}
  }
  
  openTimePickerModel(){
	$('.cart-trigger').click();
	$('body').removeClass('cart-open');
	$('#openTimePickerModel').modal('show');  
	this.updateMaxMinTime();
  }
  
  //pageRedirect
  pageRedirect(page){
	var cardItemsValid = this.cartItemDateTime();
	if (cardItemsValid=== '0') {
		return ;
	}
	
	if (this.is_d_error === '0') {
		return;
	}
	if(this.selectedOrderServiceType==='Delivery' && page==='/locations') {
		this.cartModelServiceErrorMessage='';
		$('#serviceTypeDelivery').modal({
			backdrop: 'static',
			keyboard: false
		});	
		$('#serviceTypeDelivery').modal('show');
		this.checkSavedAddressForUser();
		return;	
	}
	if (page==='register') {
		$('.cart-trigger').click();
		$('body').removeClass('cart-open');
		
		$('#login-modal').modal('hide');
		
		setTimeout(() => {
			this.router.navigateByUrl(page);
		}, 500);
	
		return ;
	}
	
	if((page==='/login' || page==='/locations' ) && (this.selectedOrderServiceType==null || this.selectedOrderServiceType==='')){
		$('.cart-trigger').click();
		$('body').removeClass('cart-open');
		setTimeout(() => {
			var r = confirm("Please select the service type first.");
			if (r == true) {
				$('.cart-trigger').click();
				$('body').addClass('cart-open');
			} else {
				$('.cart-trigger').click();
				$('body').addClass('cart-open');
			}
				
			}, 500);
		
		return false;
	} else {
		$('html').css('overflow','auto');
		this.router.navigateByUrl(page);
	}
  }
  // update the cart instruction
	openUpdateCartInstructionModal (cart, indexOfelement) {
		this.editCartObject = [];
		this.editCartObject=cart;
		this.selectedIndexOfelement = indexOfelement;
		$('.update-instruction').val('');
		$('.update-instruction').val(this.editCartObject.ItemInstructions);
		$('#updateItemInstruction').modal('show');
	}
  
	updateInst () {
		var updateInstruction = [];
		for (var i=0; i<this.cartModelData.length; i++ ) {
		var instruction = this.cartModelData[i].ItemInstructions;
		if(this.selectedIndexOfelement == i) {
			instruction = $('.update-instruction').val();
		}
		var currentdatetime = new Date();
		
		var dataTostore={
			"submenuImage": this.cartModelData[i].submenuImage,
			"ItemId": this.cartModelData[i].ItemId,
			"ItemQty":this.cartModelData[i].ItemQty,
			"ItemAmt":this.cartModelData[i].ItemAmt,
			"ItemBasePrice":this.cartModelData[i].ItemBasePrice,
			
			"ItemType": this.cartModelData[i].ItemType,
			"ItemInstructions": instruction,
			"ItemSize": this.cartModelData[i].ItemSize,
			"SizeId": this.cartModelData[i].SizeId,
			"addOns": this.cartModelData[i].addOns,
			"subMeuName": this.cartModelData[i].subMeuName,
			"date":currentdatetime.toString()

			
		};
		updateInstruction.push(dataTostore);
	  }
	  this.cartModelData = [];
	  this.cartModelData =updateInstruction;
	   localStorage.setItem('orderData', JSON.stringify(updateInstruction));

	}
	
	handleAddressChange(address) {
		$('#zipcode').val('');
		$('#apartment').val('');
		$('.addressgoogleauto').val('');
		
		var deliveryAddress = [];
		var lat = address.geometry.location.lat();
		var lng = address.geometry.location.lng();
		var fulladdress = address.formatted_address;
		$('.addressgoogleauto').val(fulladdress);

		deliveryAddress.push({lat:lat});
		deliveryAddress.push({lng:lng});
		deliveryAddress.push({fulladdress:fulladdress});
		for(let i=1; i<address.address_components.length;i++)
		{
			var mapAddress = address.address_components[i];
			if(mapAddress.long_name !=''){
				if(mapAddress.types[0] ==="administrative_area_level_1"){
                  deliveryAddress.push({state:mapAddress.long_name});
				}
				if(mapAddress.types[0] ==="locality"){
                  deliveryAddress.push({city:mapAddress.long_name});
				}
				 if(mapAddress.types[0] ==="postal_code"){
				   $('#zipcode').val(mapAddress.long_name);
				   deliveryAddress.push({zipcode:mapAddress.long_name});
				}
				if(mapAddress.types[0] ==="street_number"){
				   $('#apartment').val(mapAddress.long_name);
				   deliveryAddress.push({apartment:mapAddress.long_name});
				}
            
			}
		}
	   localStorage.setItem('deliveryAddress', JSON.stringify(deliveryAddress));
		
	}
	serviceTypeDeliveryProcessed () {
		var zipcode= $('#zipcode').val();
		var apartment= $('#apartment').val();
		var addressgoogleauto= $('.addressgoogleauto').val();
		this.cartModelServiceErrorMessage='';
		
		
		if(addressgoogleauto==='' && zipcode==='') {
			this.cartModelServiceErrorMessage='Please add the location and zip code.'
		}else if(addressgoogleauto==='') {
			this.cartModelServiceErrorMessage='Please add the location.'
		}else if(zipcode==='') {
			this.cartModelServiceErrorMessage='Please add the zip Code.'
		} else {
			$('html').css('overflow','auto');
			$('#serviceTypeDelivery').modal('hide');
			if (this.router.url==='/locations') {
				localStorage.setItem('reloadFrom', 'location');
				setTimeout(() => {
					location.reload();
				}, 500);
			} else {
				this.router.navigateByUrl('/locations');
			}
		}
		
		
	}
	cancelOrderService () {
		localStorage.removeItem('reloadFrom');
	}
	checkSavedAddressForUser () {
		var loginUserData= JSON.parse(localStorage.getItem('user_detail'));
		if (loginUserData.user_address) {
				var addressObject=[];
				for(var i=0; i<loginUserData.user_address.length; i++) {
					//converting the string to lower case
					var type = loginUserData.user_address[i].type;
					var typeLowerCase = type.toLowerCase();
					if (typeLowerCase==='home') {
						if(addressObject.length==0) {
							addressObject.push(loginUserData.user_address[i]);
						}
					}
				}
				if(addressObject.length==0 && loginUserData.user_address.length>0) {
						addressObject = [];
						addressObject.push(loginUserData.user_address[0]);
				}
				if (addressObject.length>0) {
					$('.addressgoogleauto').val(addressObject[0].address);
					$('#apartment').val(addressObject[0].apartment);
					$('#zipcode').val(addressObject[0].postal_code);
					var dAddress=[];
					dAddress.push({lat :addressObject[0].lat});
					dAddress.push({lng :addressObject[0].lng});
					dAddress.push({fulladdress :addressObject[0].address});
					dAddress.push({state :addressObject[0].state});
					dAddress.push({city :addressObject[0].city});
					dAddress.push({zipcode :addressObject[0].postal_code});
					dAddress.push({apartment :addressObject[0].apartment});
						 
				    localStorage.setItem('deliveryAddress', JSON.stringify(dAddress));

				}
				
		}
	}
	//are used to close the modal 
	closeModalMenu () {
		$('#customizeModal').modal('hide');
	}
	
	pizaToppingPriceCart (cartData:any, addOn:any)
	{
		var topingamt = addOn.pizaextra_price;
		topingamt = topingamt*cartData.ItemQty;
		return topingamt.toFixed(2);
	}
	
	loginModal ()
	{
		var cardItemsValid = this.cartItemDateTime();
		if (cardItemsValid=== '0') {
			return ;
		}
	
		if (this.selectedOrderServiceType==null || this.selectedOrderServiceType==='') {
			alert("Please select the service type first.");
			return ;
		}
		$('#login-modal').modal('show');
	}
	
	loginProccess ()
	{
	
		var loginEmail = $('#login-md-email').val();
		var loginPassword = $('#login-md-password').val();
		if (loginEmail==='') {
			this.loginErrorMessage="Please enter the email address.";
			return ;
		}
		if (loginPassword==='') {
			this.loginErrorMessage="Please enter the password.";
			return ;
		}
		this.loginErrorMessage ="";
		this.loginSpin =1;
		
		const loginData = new FormData();
		loginData.append("email", loginEmail);
		loginData.append("res_id", '49');
		loginData.append("password", loginPassword);
		loginData.append("os", 'website');


		this._http.postRequest('userlogin.php',loginData).subscribe(data => {
			this.loginSpin=0;
			if (data[0].status==='Success') {
				localStorage.setItem('isLogin' ,'1');
				localStorage.setItem('jwt_token' ,data[0].user_detail.auth_token);
				localStorage.setItem('user_detail' ,JSON.stringify(data[0].user_detail));
				$('#login-modal').modal('hide');
				this.isLogin='1';
				this.eventBus.cast('login:cal','login');
				this.router.navigateByUrl('/locations');

			} else {
				if (data[0]['email_exist']) {
					this.loginErrorMessage = "Invalid password. Your account already has already been registered . You can reset your password by going to forgot password after entering your email.";
				} else {
					this.loginErrorMessage = "Invalid Credentials. Please Try Again ...";

				}
			}
		});
		
	}
	
	loginGuestProccess () {
		localStorage.setItem('isLogin' ,'1');
		//localStorage.setItem('jwt_token' ,data[0].user_detail.auth_token);
		var data = {
			"id": "1",
			"fullname": "Guest",
			"email": "guest@gmail.com",
			"phone_no": "3222222222",
			"referal_code": "q2e",
			"image": "",
			"created_at": "1710415713",
			"login_with": "appuser",
			"status": "1",
			"billing_address": "",
			"state": "",
			"city": "",
			"curbside_vehicle_type": null,
			"customer_payment_id": "",
			"guest_login": "1",
		}

		localStorage.setItem('user_detail' ,JSON.stringify(data));
		$('#login-modal').modal('hide');
		this.isLogin='1';

		this.eventBus.cast('login:cal','login');
		this.router.navigateByUrl('/locations');

	}
	
	forGotPassword(){
		this.forGotPasswordMessageApi='';
		$('#forgotPassword-footer').modal('show');
	}
	
	forGot(){
		if (!this.forgotForm.value.forgotemail.includes('@')) {
			this.forGotPasswordMessageApi = "Invalid email address";
			return ;
		}
		
		this.isSubmittedForgot = true;
		if(this.forgotForm.invalid){
		  return;
		}
		this.forGotPasswordSpin=1;
		const forGotData = new FormData();
		forGotData.append( 'email', this.forgotForm.value.forgotemail );
		this._http.postRequest('forgot_password.php',forGotData).subscribe((reponse : any)=>{
			this.forGotPasswordSpin=0;
			this.forGotPasswordMessageApi=reponse.message;
			
		}) 
	}
	get formControlsforgot() { return this.forgotForm.controls; }

}
